import QuickLocationModal from './../common/QuickLocationModal';
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { apiClient, showToast } from '../../utils/apiClient';
import { API } from '../../config';
import { formatDate, formatDateTime, formatNotesWithBullets, getDayOfWeek, formatDateWithDay, getLocationDisplay, getLocationChipColor, getRowAlert, formatDatetimeForInput, parseUTCDatetime, getTodayInAEST, isPrepaymentApproaching, hasAppointments, getAppointmentSummary } from '../../utils/helpers';


const QuickLocationUpdateButton = ({ pet, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = () => {
    setShowModal(false);
    onUpdate();
    showToast('Location updated successfully! ✅');
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="text-sm bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded-md transition-colors"
      >
        Quick Update Location
      </button>
      
      {showModal && (
        <QuickLocationModal
          pet={pet}
          onClose={() => setShowModal(false)}
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
};


export default QuickLocationUpdateButton;
